<template>
  <div class="detail-container">
    <el-row class="tcf-row">
      <div class="card">
        <div class="card-body">
          <div class="card-content" v-loading="loading">
            <div class="detail-title">
              {{newsTitle}}
            </div>
            <div class="detail-info">
              <span><i class="el-icon-share" style="margin-right: 4px"/><span v-if="newsDetail.username!==''">{{newsDetail.username}}</span><span v-if="newsDetail.username===''">Elichain</span></span>
              <span style="margin: 0 20px;"><i class="el-icon-time" style="margin-right: 4px"/>{{newsDetail.time}}</span>
              <el-popover
                placement="bottom-start"
                trigger="hover">
                <div class="user-list">
                  <div class="user-item" v-for="u in newsUser">
                    <el-avatar :size="50" fit="cover" :src="u.photo!==null&&u.photo!==''?u.photo:u.sex==='男'?men:women"></el-avatar>
                    <div class="name">{{u.username}}</div>
                  </div>
                </div>
                <span slot="reference" style="color:#409EFF;cursor: pointer;"><i class="el-icon-view" style="margin-right: 4px"/>{{newsDetail.views}}人浏览</span>
              </el-popover>
              <span class="collect-btn" @click="operCollect(0)" v-if="newsDetail.is_collect===0"><i :class="collectLoading?'el-icon-loading':'el-icon-star-off'"></i> 收藏</span>
              <span class="collect-btn" style="color:#67C23A" @click="operCollect(1)" v-if="newsDetail.is_collect===1"><i :class="collectLoading?'el-icon-loading':'el-icon-success'"></i> 已收藏</span>
            </div>
            <div style="background: #f6f8fa;margin-top: 20px;padding:20px" v-html="newsDetail.content"></div>
          </div>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import {getNewsDetail} from '@/api/home'
import men from '@/assets/photo_men.jpg'
import women from '@/assets/photo_women.jpg'
import { collectNews } from '@/api/my'
export default {
  name: 'news_detail',
  data(){
    return{
      men: men,
      women: women,
      nid: '',
      newsDetail: {},
      newsTitle: '',
      newsUser: [],
      loading: false,
      collectLoading: false
    }
  },
  computed:{
    user: getUser
  },
  created() {
    this.tempRoute = Object.assign({}, this.$route)
    this.nid = this.$route.params && this.$route.params.nid
    this.getNewsDetail()
  },
  methods: {
    operCollect(n) {
      if (!this.collectLoading) {
        this.collectLoading = true
        const data = {
          type: 2,
          userId: this.user.dUserid,
          dataId: this.nid,
          mark: n
        }
        collectNews(data).then(response => {
          this.collectLoading = false
          this.$message({
            message: n === 1 ? '已取消收藏' : '资讯收藏成功',
            type: 'success'
          })
          this.newsDetail.is_collect = n === 0 ? 1 : 0
        }).catch(() => {
          this.collectLoading = false
        })
      }
    },
    getNewsDetail(){
      this.loading = true
      const _this = this
      let userid = null
      if(_this.user.rank===0){
        userid = _this.user.dUserid
      }else{
        userid = _this.user.userid
      }
      const data = {
        userId : userid,
        newsId : _this.nid,
        rank: _this.user.rank
      }
      getNewsDetail(data).then(response => {
        _this.newsDetail = response.data
        _this.newsTitle = _this.newsDetail.title
        _this.newsUser = response.data.nvlst
        _this.loading = false
        _this.setTagsViewTitle()
      })
    },
    setTagsViewTitle() {
      let titles = this.newsTitle
      if (titles.length > 10) {
        titles = titles.substring(0, 10) + '...'
      }
      const route = Object.assign({}, this.tempRoute, { title: titles })
      this.$store.dispatch('tagsView/updateVisitedView', route)
    }
  }

}
</script>

<style lang="scss" scoped>
  .detail-container {
    .tcf-row{
      .card{
        .card-body{
          .card-content{
            .detail-title{
              font-size: 25px;
            }
            .detail-info{
              margin-top: 20px;
              .collect-btn{
                margin-left: 20px;
                cursor: pointer;
                &:hover{
                  color:#409EFF;
                }
              }
            }
            .detail-file-title{
              font-size: 15px;
            }
          }
        }
      }
    }
  }
  .user-list{
    max-width: 440px;
    position: relative;
    max-height: 400px;
    overflow-y: auto;
    padding: 10px;
    .user-item{
      width: 50px;
      height: 80px;
      float: left;
      margin-right: 20px;
      margin-bottom: 20px;
      .name{
        width: 100%;
        position: relative;
        text-align: center;
        font-size: 12px;
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
</style>
